import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../src/styles/globals.css';
import reportWebVitals from './reportWebVitals';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import Home from './components/Home';
import InspectionComponent from './components/Inspection';
import PaymentComponent from './components/Payment';
import SuccessComponent from './components/Success';
import PlateConfirmation from './components/PlateConfirmation/PlateConfirmation';
import Summary from './components/Summary/Summary';
import Expired from './components/Payment/components/Expired';
import PlateForm from './components/PlateForm/PlateForm';
import InspectionType from './components/InspectionType';
import VehicleIdentifier from './components/VehicleIndentifier';

const routing = (
  <>
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/inspection-type" component={InspectionType} />
        <Route path="/vehicle-identifier" component={VehicleIdentifier} />
        <Route path="/plate-form" component={PlateForm} />
        <Route path="/plate-confirmation" component={PlateConfirmation} />
        <Route path="/inspection" component={InspectionComponent} />
        <Route path="/payment" component={PaymentComponent} />
        <Route path="/summary" component={Summary} />
        <Route path="/success" component={SuccessComponent} />
        <Route path="/expired" component={Expired} />
      </Switch>
    </Router>
  </>
  )

ReactDOM.render(routing, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
